import {Injectable} from '@angular/core';
import {DataTabs} from '../../shared/models/tabs-data';
import {GetConfigSiteService} from './get-config-site.service';
import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import {filter, map, skipWhile, take} from 'rxjs/operators';
import {MiscellaneousSiteForm, SubscriptionSiteForm} from '../models/site-form';
import {SiteMapperService} from './site-mapper.service';
import {NetworkSettings} from '../../shared/models/network-settings';
import {OrderMapperService} from '../../order/services/order-mapper.service';
import {select, Store} from '@ngrx/store';
import * as fromSites from '../reducers';
import {Site} from '../../shared/models/site';
import {Contact} from '../../shared/models/contact';
import {Address} from '../../shared/models/address';
import {PlayerConfigurationService} from '../../shared/services/player-configuration.service';
import * as fromShared from '../../shared/reducers';
import * as _ from 'lodash';
import {GetFormsService} from '../../shared/services/get-forms.service';
import {GetFormsServiceLocal} from './get-form-service';
import {GetConfigSharedService} from '../../shared/services/get-config-shared.service';
import {Office, Role} from '../../shared';
import * as fromRoot from '../../shared/reducers';
import * as moment from 'moment';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SiteDataService {
  subject = new BehaviorSubject<Object>('');
  // tslint:disable-next-line:no-any
  private sub$: any;
  private subscriptions = [];
  private roles$: Observable<Role[]>;
  private office$: Observable<Office[]>;
  BO_MANAGER_PLAYER;
  string;
  softOrUsb = true;
  storeCurrentClient: string;

  constructor(private getFormsService: GetFormsService,
              private getConfigSiteService: GetConfigSiteService,
              private getFormsServiceLocal: GetFormsServiceLocal,
              private siteMapperService: SiteMapperService,
              private playerConfigurationService: PlayerConfigurationService,
              private storeSites: Store<fromSites.AppState>,
              private getFormsSharedService: GetFormsService,
              private storeRoot: Store<fromShared.AppState>,
              private router: Router,
              private getConfigSharedService: GetConfigSharedService,
              private orderMapperService: OrderMapperService) {
    this.isInRole();
  }
  getCurrentClient(): void {
    this.sub$ = this.storeRoot.pipe(
      select(fromRoot.selectors.getCurrentClient),
      filter(client => client != undefined)
    ).subscribe(( client => {
      if (client) {
        this.storeCurrentClient = client.uuid;
        // this.breadcrumbData = this.getBreadConfigSiteService.getBreadConfigSiteList().data;
        // this.storeRoot.dispatch(new HeaderTitleAction({icon: 'fal fa-user' , title: client.name}));
      }
    }));
    this.subscriptions.push(this.sub$);
    this.office$ = this.storeRoot.pipe(select(fromRoot.selectors.getOffices));
  }

  isInRole(): void {
    this.roles$ = this.storeRoot.pipe(select(fromShared.selectors.getMyRoles));
    this.roles$.subscribe(roles => {
        if (roles.length > 0) {
          let index;
          index = _.findIndex(roles, ['code', 'BO_MANAGER_PLAYER']);
          if (index === -1) {
            this.BO_MANAGER_PLAYER = false;
          } else {
            this.BO_MANAGER_PLAYER = true;
          }
        }
      }
    );
  }

  // getSiteListData(): DataTabs {
  //   return {
  //     dataTabs: [
  //       {
  //         titleTab: 'Sites',
  //         contentTab: 'datatableSitesList',
  //         dataConfig: {
  //           form: this.getFormsService.getFilterSite(),
  //           groupConfigs: {'groupConfigs': [this.getConfigSite.getConfigSiteFilter()]},
  //           header: {
  //             icon: 'fa-map-marker-alt fa-lg',
  //             text: 'GENERIC_SITES',
  //             rightSideButton: {
  //               buttonTitle: 'ORDERS_NEW_TITLE',
  //               buttonIcon: 'far fa-shopping-cart',
  //               action: 'link',
  //               href: ['/', this.storeCurrentClient, 'orders', 'add']
  //             },
  //           },
  //           content: [
  //             {
  //               name: 'GENERIC_NAME_LABEL',
  //               prop: 'displayName',
  //               sortable: true,
  //               type: 'detailRouterLink',
  //               path: 'siteDetail',
  //             },
  //             {
  //               name: 'GENERIC_EXTERNAL_ID',
  //               prop: 'externalID',
  //               sortable: true,
  //               type: 'text'
  //             },
  //             {
  //               name: 'GENERIC_STATUS',
  //               prop: 'status',
  //               sortable: true,
  //               type: 'iconListSwitch',
  //               data: [
  //                 {tooltip: 'SUBSCRIPTIONS_STATUS_EXPLOIT' , icon: 'fa fa-fw fa-flag text-success', value: 3 },
  //                 {tooltip: 'SUBSCRIPTIONS_STATUS_DEMO' , icon: 'fa fa-fw fa-flask text-info', value: 2 },
  //                 {tooltip: 'SUBSCRIPTIONS_STATUS_OFF' , icon: 'fa fa-fw fa-power-off text-danger', value: 1 },
  //                 {tooltip: 'SUBSCRIPTIONS_STATUS_TO_OFF' , icon: 'fa fa-fw fa-flag-checkered text-warning', value: 0 },
  //                 {tooltip: 'SUBSCRIPTIONS_STATUS_STOP' , icon: 'fa fa-fw fa-stop text-danger', value: -1 },
  //                 {tooltip: 'SUBSCRIPTIONS_STATUS_BANKRUPTCY' , icon: 'fas fa-university text-danger', value: -2 }
  //               ]
  //             },
  //             {
  //               name: 'GENERIC_COUNTRY',
  //               prop: 'countryCode',
  //               sortable: true,
  //               type: 'country',
  //             },
  //             {
  //               name: 'GENERIC_ADDRESS',
  //               prop: 'Address_Line1',
  //               sortable: true,
  //               type: 'text'
  //             },
  //             {
  //               name: 'GENERIC_ZIP',
  //               prop: 'Address_Zip',
  //               sortable: true,
  //               type: 'text'
  //             },
  //             {
  //               name: 'GENERIC_CITY',
  //               prop: 'Address_City',
  //               sortable: true,
  //               type: 'text'
  //             },
  //             {
  //               name: 'GENERIC_COMPANY',
  //               prop: 'companyName',
  //               sortable: true,
  //               type: 'detailRouterLink',
  //               path: 'companyDetail',
  //             },
  //             {
  //               name: '',
  //               prop: '',
  //               sortable: false,
  //               type: 'iconModal',
  //               icon: {
  //                 modal: 'Exchange',
  //                 class: 'fal fa-exchange fa-lg',
  //                 tooltip:  'ORDERS_EXCHANGE_TITLE',
  //               }
  //             },
  //           ]
  //         },
  //       }
  //     ]
  //   }
  // }
  getCompanySubListDataRole(): DataTabs {
    return {
            dataTabs: [
              {
                titleTab: 'Subscription',
                contentTab: 'subscriptionsList',
                dataConfig: {
                  form: this.getFormsService.getFilterSubscription(),
                  groupConfigs: this.getConfigSiteService.getSubscriptionFilterBillingRole(),
                  header :  {
                    exportExcel: false,
                    icon: 'fal fa-building',
                    text: 'Subscriptions',
                    // rightSideButton: {
                    //   buttonTitle: 'CONTRACT_LINK_MODAL_LINK_CONTRACT',
                    //   buttonIcon: 'fad fa-link',
                    //   action: 'openModal',
                    // },
                  } ,
                  content: [
                    {
                      name: 'checkBox',
                      prop: 'checkBox',
                      sortable: false,
                      type: 'checkBox',
                      hideIfColumnEmpty: 'companyUuid'
                    },
                    {
                      name: '',
                      prop: 'serviceId',
                      sortable: true,
                      type: 'service'
                    },
                    {
                      name: 'GENERIC_SUBSCRIPTION_NAME',
                      prop: 'subscriptionName',
                      sortable: true,
                      type: 'detailRouterLink',
                      path: 'SubName',
                    },
                    {
                      name: 'GENERIC_STATUS',
                      prop: 'status',
                      sortable: true,
                      type: 'iconListSwitch',
                      data: [
                        {tooltip: 'SUBSCRIPTIONS_STATUS_EXPLOIT' , icon: 'fa fa-fw fa-flag text-success', value: 3 },
                        {tooltip: 'SUBSCRIPTIONS_STATUS_DEMO' , icon: 'fa fa-fw fa-flask text-info', value: 2 },
                        {tooltip: 'SUBSCRIPTIONS_STATUS_OFF' , icon: 'fa fa-fw fa-power-off text-danger', value: 1 },
                        {tooltip: 'SUBSCRIPTIONS_STATUS_TO_OFF' , icon: 'fa fa-fw fa-flag-checkered text-warning', value: 0 },
                        {tooltip: 'SUBSCRIPTIONS_STATUS_STOP' , icon: 'fa fa-fw fa-stop text-danger', value: -1 },
                        {tooltip: 'SUBSCRIPTIONS_STATUS_BANKRUPTCY' , icon: 'fas fa-university text-danger', value: -2 }
                      ]
                    },
                    {
                      name: 'ORDERS_LIST_DELIVERY_DATE',
                      prop: 'deliveryDate',
                      sortable: true,
                      type: 'date'
                    },
                    {
                      name: 'GENERIC_PRODUCT',
                      prop: 'productName',
                      sortable: true,
                      type: 'text'
                    },
                    {
                      name: '',
                      prop: '',
                      sortable: false,
                      type: 'iconModal',
                      icon: {
                        modal: 'Exchange',
                        class: 'fal fa-exchange fa-lg',
                        tooltip:  'ORDERS_EXCHANGE_TITLE',
                      }
                    },
                    {
                      name: 'M_MENU_C_CONTEXTUEL',
                      prop: '',
                      sortable: false,
                    },
                  ]
                },
              }
            ]
          }
         }
  getCompanySubListDataRole2(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Subscription',
          contentTab: 'subscriptionsList',
          dataConfig: {
            form: this.getFormsService.getFilterSubscription(),
            groupConfigs: this.getConfigSiteService.getSubscriptionFilterBillingRole(),
            header :  {
              exportExcel: false,
              icon: 'fal fa-building',
              text: 'Subscriptions',
              // rightSideButton: {
              //   buttonTitle: 'CONTRACT_LINK_MODAL_LINK_CONTRACT',
              //   buttonIcon: 'fad fa-link',
              //   action: 'openModal',
              // },
            } ,
            content: [
              {
                name: '',
                prop: 'serviceId',
                sortable: true,
                type: 'service'
              },
              {
                name: 'GENERIC_SUBSCRIPTION_NAME',
                prop: 'subscriptionName',
                sortable: true,
                type: 'detailRouterLink',
                path: 'SubName',
              },
              {
                name: 'GENERIC_STATUS',
                prop: 'status',
                sortable: true,
                type: 'iconListSwitch',
                data: [
                  {tooltip: 'SUBSCRIPTIONS_STATUS_EXPLOIT' , icon: 'fa fa-fw fa-flag text-success', value: 3 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_DEMO' , icon: 'fa fa-fw fa-flask text-info', value: 2 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_OFF' , icon: 'fa fa-fw fa-power-off text-danger', value: 1 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_TO_OFF' , icon: 'fa fa-fw fa-flag-checkered text-warning', value: 0 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_STOP' , icon: 'fa fa-fw fa-stop text-danger', value: -1 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_BANKRUPTCY' , icon: 'fas fa-university text-danger', value: -2 }
                ]
              },
              {
                name: 'ORDERS_LIST_DELIVERY_DATE',
                prop: 'deliveryDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_PRODUCT',
                prop: 'productName',
                sortable: true,
                type: 'text'
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'Exchange',
                  class: 'fal fa-exchange fa-lg',
                  tooltip:  'ORDERS_EXCHANGE_TITLE',
                }
              },
              {
                name: 'M_MENU_C_CONTEXTUEL',
                prop: '',
                sortable: false,
              },
            ]
          },
        }
      ]
    }
  }
  getProjectsListData(): DataTabs {
    // @ts-ignore
    return {
      dataTabs: [
        {
          titleTab: 'Projects',
          contentTab: 'ProjectsList',
          dataConfig: {
            form: this.getFormsService.getFilterProject(),
            groupConfigs: this.getConfigSiteService.getProjectsFilter(),
            header :  {
              exportExcel: false,
              icon: 'fas fa-tasks-alt',
              text: 'Projects',
              rightSideButton: {
                buttonTitle: 'GENERIC_ADD_PROJECT',
                buttonIcon: 'fa-project-diagram far',
                action: 'openModal',
              },
            } ,
            content: [
              {
                name: 'PROJECT_LIST_NAME',
                prop: 'name',
                sortable: true,
                type: 'text'
              },
              {
                name: 'PROJECT_LIST_SF_PROJECT_ID',
                prop: 'sfProjectID',
                sortable: true,
                type: 'text'
              },
              {
                name: 'PROJECT_SAP_PROJECT_ID',
                prop: 'sapProjectID',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_CREATED',
                prop: 'created',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_UPDATED',
                prop: 'updated',
                sortable: true,
                type: 'date',
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'EditProject',
                  class: 'fas fa-pencil-alt',
                  tooltip: 'GENERIC_ADD_PROJECT',
                }
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'RemoveProject',
                  class: 'fal fa-trash-alt',
                  tooltip: 'GENERIC_REMOVE',
                }
              },

            ]
          },
        }
      ]
    }
  }
  getCompanySubListData(): DataTabs {
    // @ts-ignore
    return {
      dataTabs: [
        {
          titleTab: 'Subscription',
          contentTab: 'subscriptionsList',
          dataConfig: {
            form: this.getFormsService.getFilterSubscription(),
            groupConfigs: this.getConfigSiteService.getSubscriptionFilter(),
            mode: 'SiteSubscriptionList',
            header: {
              exportExcel: true,
              icon: 'fal fa-building',
              text: 'Contract links',
              // rightSideButton: {
              //   buttonTitle: 'CONTRACT_LINK_MODAL_LINK_CONTRACT',
              //   buttonIcon: 'fad fa-link',
              //   action: 'openModal',
              // },
            },
            content: [
              {
                name: 'checkBox',
                prop: 'checkBox',
                sortable: false,
                type: 'checkBox',
                hideIfColumnEmpty: 'companyUuid'
              },
              {
                name: '',
                prop: 'serviceId',
                sortable: true,
                type: 'service'
              },
              {
                name: 'GENERIC_SUBSCRIPTION_NAME',
                prop: 'subscriptionName',
                sortable: true,
                type: 'detailRouterLink',
                path: 'SubName',
                fragment: 'Subscription'
              },
              {
                name: 'GENERIC_STATUS',
                prop: 'status',
                sortable: true,
                type: 'iconListSwitch',
                data: [
                  {tooltip: 'SUBSCRIPTIONS_STATUS_EXPLOIT', icon: 'fa fa-fw fa-flag text-success', value: 3},
                  {tooltip: 'SUBSCRIPTIONS_STATUS_DEMO', icon: 'fa fa-fw fa-flask text-info', value: 2},
                  {tooltip: 'SUBSCRIPTIONS_STATUS_OFF', icon: 'fa fa-fw fa-power-off text-danger', value: 1},
                  {tooltip: 'SUBSCRIPTIONS_STATUS_TO_OFF', icon: 'fa fa-fw fa-flag-checkered text-warning', value: 0},
                  {tooltip: 'SUBSCRIPTIONS_STATUS_STOP', icon: 'fa fa-fw fa-stop text-danger', value: -1},
                  {tooltip: 'SUBSCRIPTIONS_STATUS_BANKRUPTCY', icon: 'fas fa-university text-danger', value: -2}
                ]
              },
              {
                name: 'GENERIC_START_DATE',
                prop: 'startBilling',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_END_DATE',
                prop: 'endBilling',
                sortable: true,
                type: 'date',
              },
              {
                name: 'ORDERS_LIST_DELIVERY_DATE',
                prop: 'deliveryDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_PRICE',
                prop: 'price',
                sortable: true,
                type: 'concatenatePrice',
                concatenate: ['price', 'currencyIsoCode'],
                emptyData: 'CONTRACT_LIST_PRICE_EMPTY_DATA'
              },

              {
                name: 'GENERIC_CONTRACT_NAME',
                prop: 'contractName',
                sortable: true,
                type: 'routerLink',
                path: 'contractNameSub'
              },
              {
                name: 'GENERIC_PRODUCT',
                prop: 'productName',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_LAST_INVOICE_CALCULATION',
                prop: 'lastInvoiceCalculation',
                sortable: true,
                type: 'date'
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'Exchange',
                  class: 'fal fa-exchange fa-lg',
                  tooltip: 'ORDERS_EXCHANGE_TITLE',
                }
              },
              {
                name: 'M_MENU_C_CONTEXTUEL',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'CloseSiteBillingModal',
                  class: 'fal fa-window-close',
                  tooltip: 'CONTRACT_CLOSE_SITE_BILLING_MODAL_TITLE',
                  tooltipDisabled: 'SUBSCRIPTION_END_DISABLED_IN_MENU',
                  hide: (row): boolean => (row.companyUuid),
                  disabledFn: (row): boolean => (row.status === 1 && (moment(row.endBilling).year() < new Date().getFullYear())),
                }
              },
            ]
          },
        }
      ]
    }
  }
  getSubListData(): DataTabs {
  // @ts-ignore
    return {
  dataTabs: [
    {
      titleTab: 'Subscription',
      contentTab: 'subscriptionsListSimple',
      dataConfig: {
        form: this.getFormsService.getFilterSubscriptionSimpleList(),
        groupConfigs: this.getConfigSiteService.getSubscriptionFilterSimple(),
        mode: 'SiteSubscriptionList',
        header :  {
          exportExcel: true,
          icon: 'fal fa-building',
          text: 'Subscriptions',
          // rightSideButton: {
          //   buttonTitle: 'CONTRACT_LINK_MODAL_LINK_CONTRACT',
          //   buttonIcon: 'fad fa-link',
          //   action: 'openModal',
          // },
        } ,
        content: [
          {
            name: 'checkBox',
            prop: 'checkBox',
            sortable: false,
            type: 'checkBox',
          },
          {
            name: '',
            prop: 'serviceId',
            sortable: true,
            type: 'service'
          },
          {
            name: 'GENERIC_SITES',
            prop: 'siteName',
            sortable: true,
            type: 'detailRouterLink',
            path: 'SubName',
            fragment: 'Subscription'
          },
          {
            name: 'GENERIC_SUBSCRIPTION_NAME',
            prop: 'subscriptionName',
            sortable: true,
            type: 'detailRouterLink',
            path: 'SubName',
            fragment: 'Subscription'
          },
          {
            name: 'GENERIC_STATUS',
            prop: 'status',
            sortable: true,
            type: 'iconListSwitch',
            data: [
              {tooltip: 'SUBSCRIPTIONS_STATUS_EXPLOIT' , icon: 'fa fa-fw fa-flag text-success', value: 3 },
              {tooltip: 'SUBSCRIPTIONS_STATUS_DEMO' , icon: 'fa fa-fw fa-flask text-info', value: 2 },
              {tooltip: 'SUBSCRIPTIONS_STATUS_OFF' , icon: 'fa fa-fw fa-power-off text-danger', value: 1 },
              {tooltip: 'SUBSCRIPTIONS_STATUS_TO_OFF' , icon: 'fa fa-fw fa-flag-checkered text-warning', value: 0 },
              {tooltip: 'SUBSCRIPTIONS_STATUS_STOP' , icon: 'fa fa-fw fa-stop text-danger', value: -1 },
              {tooltip: 'SUBSCRIPTIONS_STATUS_BANKRUPTCY' , icon: 'fas fa-university text-danger', value: -2 }
            ]
          },
          {
            name: 'ORDERS_LIST_DELIVERY_DATE',
            prop: 'deliveryDate',
            sortable: true,
            type: 'date'
          },
          {
            name: 'GENERIC_PRODUCT',
            prop: 'productName',
            sortable: true,
            type: 'text'
          },
          {
            name: 'GENERIC_PLAYER_NAME',
            prop: 'playerName',
            sortable: true,
            type: 'externalPortal'
          },
          {
            name: '',
            prop: '',
            sortable: false,
            type: 'iconModal',
            icon: {
              modal: 'Exchange',
              class: 'fal fa-exchange fa-lg',
              tooltip:  'ORDERS_EXCHANGE_TITLE',
            }
          },
          {
            name: 'M_MENU_C_CONTEXTUEL',
            prop: '',
            sortable: false,
            type: 'iconModal',
            icon: {
              modal: 'CloseSiteBillingModal',
              class: 'fal fa-window-close',
              tooltip: 'CONTRACT_CLOSE_SITE_BILLING_MODAL_TITLE',
              tooltipDisabled: 'SUBSCRIPTION_END_DISABLED_IN_MENU',
              hide: (row): boolean => (row.companyUuid),
              disabledFn: (row): boolean => (row.status === 1 && (moment(row.endBilling).year() < new Date().getFullYear())),
            }
          },
        ]
      },
    }
  ]
}
}
  getSiteDetailsMultiData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Subscriptions',
          contentTab: 'subscriptionsList',
          dataConfig: {
            form: this.getFormsService.getSubscription(),
            groupConfigs: this.getConfigSiteService.getSubscriptionConfigs(),
            content: [
              {
                name: '',
                prop: 'service.id',
                sortable: true,
                type: 'service'
              },
              {
                name: 'ORDERS_LIST_SUBSCRIPTION_NAME',
                prop: 'displayName',
                sortable: true,
                type: 'detailSubRouterLink',
              },
              {
                name: 'GENERIC_PLAYER_NAME',
                prop: 'players',
                sortable: true,
                type: 'playerName'
              },
              {
                name: 'GENERIC_STATUS',
                prop: 'status',
                sortable: true,
                type: 'iconListSwitch',
                data: [
                  {tooltip: 'SUBSCRIPTIONS_STATUS_EXPLOIT' , icon: 'fa fa-fw fa-flag text-success', value: 3 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_DEMO' , icon: 'fa fa-fw fa-flask text-info', value: 2 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_OFF' , icon: 'fa fa-fw fa-power-off text-danger', value: 1 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_TO_OFF' , icon: 'fa fa-fw fa-flag-checkered text-warning', value: 0 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_STOP' , icon: 'fa fa-fw fa-stop text-danger', value: -1 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_BANKRUPTCY' , icon: 'fas fa-university text-danger', value: -2 }
                ]
              },
              {
                name: 'GENERIC_CLOSE_SUBSCRIPTION',
                prop: 'closed',
                sortable: true,
                type: 'date',
              },
              {
                name: 'GENERIC_PRODUCT_NAME',
                prop: 'product.name',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_CULTURES',
                prop: 'cultures',
                sortable: true,
                type: 'simpleArray',
              },
              {
                name: 'SITE_FILTER_LAST_CONNECTION',
                prop: 'players',
                sortable: true,
                type: 'LastConnectionDate',
              },
              {
                name: 'M_MENU_C_CONTEXTUEL' ,
                prop: '',
                sortable: false,
                type: 'iconRouter',
                data: [
                  {
                    name: 'exchange',
                    prop: '',
                    sortable: false,
                    type: 'iconModalRouter',
                    icon: {
                      modal: null,
                      class:  'fad fa-exchange' ,
                      tooltip: 'ORDERS_EXCHANGE_TITLE'
                    }
                  },
                ]
              },
            ]
          }
        },
        {
          titleTab: 'Site',
          contentTab: 'siteEditable',
          dataConfig: {
            form: this.getFormsService.getSubscriptionMulti(),
            groupConfigs: this.getConfigSiteService.getSiteConfigs(),
            content: this.mapDataSubscriptionToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          }
        },
        {
          titleTab: 'Players',
          contentTab: 'datatablePlayerList',
          dataConfig: {
            form: this.getFormsService.getFilterPlayer(),
            groupConfigs: this.getConfigSiteService.getPlayersConfigs(),
            header: {
              icon: 'fal fa-hdd',
              text: 'GENERIC_PLAYERS',
            },
            content: [
              {
                name: 'GENERIC_PLAYER_NAME',
                prop: 'displayName',
                sortable: true,
                type: 'externalPortal'
              },
              {
                name: 'GENERIC_IS_DEFAULT',
                prop: 'isDefault',
                sortable: true,
                type: 'iconModal',
                icon: {
                  modal: 'setDefaultModal',
                  classFn: (row): string => (row.isDefault ? 'fas fa-star' : 'fal fa-star'), // default: true -> fas fa-star - default: false -> fal fa-star
                  tooltip: 'PLAYER_LIST_ICON_TITLE_SET_DEFAULT',
                  disabled: this.canChangeDefault(this.storeSites.pipe(select(fromSites.selectors.getSite))),
                  disabledFn: (row): boolean => row.isDefault || row.deleted,
                }
              },
              {
                name: 'GENERIC_DEVICE_ID',
                prop: 'deviceID',
                sortable: true,
                type: 'text'
              },
              {
                name: 'ORDERS_LIST_SUBSCRIPTION_NAME',
                prop: 'subscription.name',
                sortable: true,
                type: 'detailSubRouterLink',
              },
              {
                name: 'GENERIC_PRODUCT_NAME',
                prop: 'productName',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_MODEL',
                prop: 'deviceModel',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_FIRMWARE',
                prop: 'deviceFirmware',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_MAC_ADDRESS',
                prop: 'deviceMacAddress',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_LAST_CONNECTION',
                prop: 'lastConnection',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_CREATED',
                prop: 'created',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_REMOVED',
                prop: 'deleted',
                sortable: true,
                type: 'date'
              },
              {
                name: 'PLAYER_LIST_ACTIVE_CODE',
                prop: 'activationCode',
                hideTitle: this.softOrUsb,
                type: 'text'
              },
              {
                name: 'PLAYER_LIST_LICENCE_MODIFICATION_DATE',
                prop: 'licenceModificationDate',
                hideTitle: this.softOrUsb,
                hideData: this.softOrUsb,
                type: 'date'
              },
              {
                name: 'PLAYER_LIST_ACTIVATION',
                prop: 'isActivated',
                hideTitle: this.softOrUsb,
                type: 'boolean'
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'setupModeModal',
                  class: 'fas fa-cog',
                  tooltip: 'GENERIC_SETUP_PLAYER',
                  hide: (row): boolean => (row.setupMode === 'push') ,
                }
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'resetActivationCode',
                  class: 'far fa-repeat-alt',
                  tooltip: 'GENERIC_RESET_CODE',
                  hide: (row): boolean => (row.isActivated) ,
                }
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'removeModal',
                  class: 'fal fa-trash-alt',
                  tooltip: 'GENERIC_RESET_CODE',
                  disabled: this.getOrderOpenStatus(this.storeSites.pipe(select(fromSites.selectors.getSite))),
                  disabledFn: (row): boolean => row.deleted,
                  hide: (row): boolean => this.BO_MANAGER_PLAYER,
                }
              },
            ]
          },
        },
        {
          titleTab: 'Addresses',
          contentTab: 'addressesEditable',
          dataConfig: {
            form: this.getFormsService.getAddresses(),
            groupConfigs: this.getConfigSiteService.getAddressesConfigs(),
            content: this.mapDataAddressesToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
        {
          titleTab: 'Contacts',
          contentTab: 'contactsEditable',
          dataConfig: {
            form: this.getFormsServiceLocal.getContacts(),
            groupConfigs: this.getConfigSiteService.getContactConfigs(),
            content: this.mapDataContactToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
        {
          titleTab: 'Miscellaneous',
          contentTab: 'miscellaneousEditable',
          dataConfig: {
            form: this.getFormsService.getMiscellaneous(),
            groupConfigs: this.getConfigSiteService.getMiscellaneousConfigs(),
            content: this.mapDataMiscellaneousToFormMulti(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
      ]
    }
  }
  getSubscriptionDetailsMultiData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Players',
          contentTab: 'datatablePlayerList',
          dataConfig: {
            form: this.getFormsService.getFilterPlayer(),
            groupConfigs: this.getConfigSiteService.getPlayersConfigs(),
            header: {
              icon: 'fal fa-hdd',
              text: 'GENERIC_PLAYERS',
              rightSideButton: {
                buttonTitle: 'ORDER_LIST_ADD_DEVICE_ADD_PLAYER',
                buttonIcon: 'fal fa-hdd',
                action: 'link',
                href: ['/', 'shippings', 'add'],
                role: 'BO_MANAGER_PLAYER'
              },
            },
            content: [
              {
                name: 'GENERIC_PLAYER_NAME',
                prop: 'displayName',
                sortable: true,
                type: 'externalPortal'
              },
              {
                name: 'GENERIC_IS_DEFAULT',
                prop: 'isDefault',
                sortable: true,
                type: 'iconModal',
                icon: {
                  modal: 'setDefaultModal',
                  classFn: (row): string => (row.isDefault ? 'fas fa-star' : 'fal fa-star'), // default: true -> fas fa-star - default: false -> fal fa-star
                  tooltip: 'PLAYER_LIST_ICON_TITLE_SET_DEFAULT',
                  disabled: this.canChangeDefault(this.storeSites.pipe(select(fromSites.selectors.getSite))),
                  disabledFn: (row): boolean => row.isDefault || row.deleted,
                }
              },
              {
                name: 'GENERIC_DEVICE_ID',
                prop: 'deviceID',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_PRODUCT_NAME',
                prop: 'productName',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_MODEL',
                prop: 'deviceModel',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_FIRMWARE',
                prop: 'deviceFirmware',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_MAC_ADDRESS',
                prop: 'deviceMacAddress',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_LAST_CONNECTION',
                prop: 'lastConnection',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_CREATED',
                prop: 'created',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_REMOVED',
                prop: 'deleted',
                sortable: true,
                type: 'date'
              },
              {
                name: 'PLAYER_LIST_ACTIVE_CODE',
                prop: 'activationCode',
                hideTitle: this.softOrUsb,
                type: 'text'
              },
              {
                name: 'PLAYER_LIST_LICENCE_MODIFICATION_DATE',
                prop: 'licenceModificationDate',
                hideTitle: this.softOrUsb,
                hideData: this.softOrUsb,
                type: 'date'
              },
              {
                name: 'PLAYER_LIST_ACTIVATION',
                prop: 'isActivated',
                hideTitle: this.softOrUsb,
                type: 'boolean'
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'setupModeModal',
                  class: 'fas fa-cog',
                  tooltip: 'GENERIC_SETUP_PLAYER',
                  hide: (row): boolean => (row.setupMode === 'push') ,
                }
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'resetActivationCode',
                  class: 'far fa-repeat-alt',
                  tooltip: 'GENERIC_RESET_CODE',
                  hide: (row): boolean => (row.isActivated) ,
                }
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'removeModal',
                  class: 'fal fa-trash-alt',
                  tooltip: 'GENERIC_RESET_CODE',
                  disabled: this.getOrderOpenStatusWithRom(this.storeSites.pipe(select(fromSites.selectors.getSite))),
                  disabledFn: (row): boolean => row.deleted,
                  hide: (row): boolean => this.BO_MANAGER_PLAYER,
                }
              },
            ]
          },
        },

        {
          titleTab: 'Subscription',
          contentTab: 'subscriptionMultiEditable',
          dataConfig: {
            form: this.getFormsService.getSubscriptionDetail(),
            groupConfigs: this.getConfigSiteService.getSubscriptionDetailConfigs(),
            content: this.mapDataSubscriptionToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          }
        },
        {
          titleTab: 'Network',
          contentTab: 'networkEditable',
          dataConfig: {
            form: this.getFormsService.getNetworkForm(),
            groupConfigs: this.getConfigSiteService.getNetworkConfigs(),
            content: this.mapDataNetworkToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
        {
          titleTab: 'Miscellaneous',
          contentTab: 'miscellaneousEditable',
          dataConfig: {
            form: this.getFormsService.getMiscellaneous(),
            groupConfigs: this.getConfigSiteService.getMiscellaneousConfigs(),
            content: this.mapDataMiscellaneousToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
        {
          titleTab: 'Configuration',
          contentTab: 'playerConfigurationEditable',
          dataConfig: {
            form: null,
            groupConfigs: null,
          },
        },
        {
          titleTab: 'Shippings',
          contentTab: 'containerShipping',
          dataConfig: null,
          role: 'BO_SHIPPING_VIEW',
        },
        {
          titleTab: 'Publications',
          contentTab: 'datatablePublicationList',
          dataConfig: {
            form: this.getFormsService.getFilterPublication(),
            groupConfigs: this.getConfigSiteService.getPublicationsConfigs(),
            content: [
              {
                name: 'GENERIC_PUBLICATION_TYPE',
                prop: 'type',
                sortable: true,
                type: 'icon',
                icon: {
                  classFn: (row): string => (row.type === 'Publication_Video' ? 'fa fa-film' :
                    (row.type === 'Publication_Audio_Commercial' ? 'fa fa-bullhorn' : 'fa fa-volume-up')),
                }
              },
              {
                name: 'GENERIC_PUBLICATION_NAME',
                prop: 'name',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_PUBLICATION_PACKAGE_ID',
                prop: 'packageID',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_PUBLICATION_VERSION',
                prop: 'version',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_PUBLICATION_STARTDATE',
                prop: 'startDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_PUBLICATION_ENDDATE',
                prop: 'endDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_PUBLICATION_CREATED',
                prop: 'created',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_PUBLICATION_STATUS',
                prop: 'status',
                sortable: true,
                type: 'select',
                data: [
                  { id: 1, name: 'Success' },
                  { id: 0, name: 'In process' },
                  { id: -1, name: 'Failed' }
                ]
              },
              {
                name: 'GENERIC_PUBLICATION_TRANSFERMODE',
                prop: 'sent',
                sortable: true,
                type: 'select',
                data: [
                  { id: 0, name: 'None' },
                  { id: 1, name: 'Online' },
                  { id: 2, name: 'Offline' },
                  { id: 3, name: 'CD' },
                  { id: 4, name: 'SD' },
                  { id: 5, name: 'USB' },
                  { id: 6, name: 'Stream' }
                ]
              }
            ]
          },
        },
        {
          titleTab: 'Invoices',
          contentTab: 'invoicesList',
          dataConfig: this.getInvoicesListData().dataTabs[0].dataConfig,
          role: 'BO_BILLING_INVOICES_VIEW',

        },
        {
          titleTab: 'Contracts',
          contentTab: 'datatableContracts',
          dataConfig: this.getSiteContractsListData().dataTabs[0].dataConfig,
          role: 'BO_BILLING_INVOICES_VIEW',
        },
      ]
    }
  }

  getSiteDetailsData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Players',
          contentTab: 'datatablePlayerList',
          dataConfig: {
            form: this.getFormsService.getFilterPlayer(),
            groupConfigs: this.getConfigSiteService.getPlayersConfigs(),
            header: {
              icon: 'fal fa-hdd',
              text: 'GENERIC_PLAYERS',
              rightSideButton: {
                buttonTitle: 'ORDER_LIST_ADD_DEVICE_ADD_PLAYER',
                buttonIcon: 'fal fa-hdd',
                action: 'link',
                href: ['/', 'shippings', 'add'],
                role: 'BO_MANAGER_PLAYER'
              },
            },
            content: [
              {
                name: 'GENERIC_PLAYER_NAME',
                prop: 'displayName',
                sortable: true,
                type: 'externalPortal'
              },
              {
                name: 'GENERIC_IS_DEFAULT',
                prop: 'isDefault',
                sortable: true,
                type: 'iconModal',
                icon: {
                  modal: 'setDefaultModal',
                  classFn: (row): string => (row.isDefault ? 'fas fa-star' : 'fal fa-star'), // default: true -> fas fa-star - default: false -> fal fa-star
                  tooltip: 'PLAYER_LIST_ICON_TITLE_SET_DEFAULT',
                  disabled: this.canChangeDefault(this.storeSites.pipe(select(fromSites.selectors.getSite))),
                  disabledFn: (row): boolean => row.isDefault || row.deleted,
                }
              },
              {
                name: 'GENERIC_DEVICE_ID',
                prop: 'deviceID',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_PRODUCT_NAME',
                prop: 'productName',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_MODEL',
                prop: 'deviceModel',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_FIRMWARE',
                prop: 'deviceFirmware',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_MAC_ADDRESS',
                prop: 'deviceMacAddress',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_LAST_CONNECTION',
                prop: 'lastConnection',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_CREATED',
                prop: 'created',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_REMOVED',
                prop: 'deleted',
                sortable: true,
                type: 'date'
              },
              {
                name: 'PLAYER_LIST_ACTIVE_CODE',
                prop: 'activationCode',
                hideTitle: this.softOrUsb,
                type: 'text'
              },
              {
                name: 'PLAYER_LIST_LICENCE_MODIFICATION_DATE',
                prop: 'licenceModificationDate',
                hideTitle: this.softOrUsb,
                hideData: this.softOrUsb,
                type: 'date'
              },
              {
                name: 'PLAYER_LIST_ACTIVATION',
                prop: 'isActivated',
                hideTitle: this.softOrUsb,
                type: 'boolean'
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'setupModeModal',
                  class: 'fas fa-cog',
                  tooltip: 'GENERIC_SETUP_PLAYER',
                  hide: (row): boolean => (row.setupMode === 'push') ,
                }
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'resetActivationCode',
                  class: 'far fa-repeat-alt',
                  tooltip: 'GENERIC_RESET_CODE',
                  hide: (row): boolean => (row.isActivated) ,
                }
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                    modal: 'removeModal',
                    class: 'fal fa-trash-alt',
                    tooltip: 'GENERIC_RESET_CODE',
                    disabled: this.getOrderOpenStatus(this.storeSites.pipe(select(fromSites.selectors.getSite))),
                    disabledFn: (row): boolean => row.deleted,
                    hide: (row): boolean => this.BO_MANAGER_PLAYER,
                  }
              },
            ]
          },
        },

        {
          titleTab: 'Subscription',
          contentTab: 'subscriptionEditable',
          dataConfig: {
            form: this.getFormsService.getSubscription(),
            groupConfigs: this.getConfigSiteService.getSubscriptionConfigs(),
            content: this.mapDataSubscriptionToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          }
        },
        {
          titleTab: 'Addresses',
          contentTab: 'addressesEditable',
          dataConfig: {
            form: this.getFormsService.getAddresses(),
            groupConfigs: this.getConfigSiteService.getAddressesConfigs(),
            content: this.mapDataAddressesToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
        {
          titleTab: 'Contacts',
          contentTab: 'contactsEditable',
          dataConfig: {
            form: this.getFormsServiceLocal.getContacts(),
            groupConfigs: this.getConfigSiteService.getContactConfigs(),
            content: this.mapDataContactToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
        {
          titleTab: 'Network',
          contentTab: 'networkEditable',
          dataConfig: {
            form: this.getFormsService.getNetworkForm(),
            groupConfigs: this.getConfigSiteService.getNetworkConfigs(),
            content: this.mapDataNetworkToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
        {
          titleTab: 'Miscellaneous',
          contentTab: 'miscellaneousEditable',
          dataConfig: {
            form: this.getFormsService.getMiscellaneous(),
            groupConfigs: this.getConfigSiteService.getMiscellaneousConfigs(),
            content: this.mapDataMiscellaneousToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
        {
          titleTab: 'Configuration',
          contentTab: 'playerConfigurationEditable',
          dataConfig: {
            form: null,
            groupConfigs: null,
          },
        },
        {
          titleTab: 'Shippings',
          contentTab: 'containerShipping',
          dataConfig: null,
          role: 'BO_SHIPPING_VIEW',
        },
        {
          titleTab: 'Publications',
          contentTab: 'datatablePublicationList',
          dataConfig: {
            form: this.getFormsService.getFilterPublication(),
            groupConfigs: this.getConfigSiteService.getPublicationsConfigs(),
            content: [
              {
                name: 'GENERIC_PUBLICATION_TYPE',
                prop: 'type',
                sortable: true,
                type: 'icon',
                icon: {
                  classFn: (row): string => (row.type === 'Publication_Video' ? 'fa fa-film' :
                    (row.type === 'Publication_Audio_Commercial' ? 'fa fa-bullhorn' : 'fa fa-volume-up')),
                }
              },
              {
                name: 'GENERIC_PUBLICATION_NAME',
                prop: 'name',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_PUBLICATION_PACKAGE_ID',
                prop: 'packageID',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_PUBLICATION_VERSION',
                prop: 'version',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_PUBLICATION_STARTDATE',
                prop: 'startDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_PUBLICATION_ENDDATE',
                prop: 'endDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_PUBLICATION_CREATED',
                prop: 'created',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_PUBLICATION_STATUS',
                prop: 'status',
                sortable: true,
                type: 'select',
                data: [
                  { id: 1, name: 'Success' },
                  { id: 0, name: 'In process' },
                  { id: -1, name: 'Failed' }
                ]
              },
              {
                name: 'GENERIC_PUBLICATION_TRANSFERMODE',
                prop: 'sent',
                sortable: true,
                type: 'select',
                data: [
                  { id: 0, name: 'None' },
                  { id: 1, name: 'Online' },
                  { id: 2, name: 'Offline' },
                  { id: 3, name: 'CD' },
                  { id: 4, name: 'SD' },
                  { id: 5, name: 'USB' },
                  { id: 6, name: 'Stream' }
                ]
              }
            ]
          },
        },
        {
          titleTab: 'Invoices',
          contentTab: 'invoicesList',
          dataConfig: this.getInvoicesListData().dataTabs[0].dataConfig,
          role: 'BO_BILLING_INVOICES_VIEW',

        },
        {
          titleTab: 'Contracts',
          contentTab: 'datatableContracts',
          dataConfig: this.getSiteContractsListData().dataTabs[0].dataConfig,
          role: 'BO_BILLING_INVOICES_VIEW',
        },
      ]
    }
  }

  getSiteDetailsDataNoPlayer(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Subscription',
          contentTab: 'subscriptionEditable',
          dataConfig: {
            form: this.getFormsService.getSubscription(),
            groupConfigs: this.getConfigSiteService.getSubscriptionConfigs(),
            content: this.mapDataSubscriptionToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          }
        },
        {
          titleTab: 'Addresses',
          contentTab: 'addressesEditable',
          dataConfig: {
            form: this.getFormsService.getAddresses(),
            groupConfigs: this.getConfigSiteService.getAddressesConfigs(),
            content: this.mapDataAddressesToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
        {
          titleTab: 'Contacts',
          contentTab: 'contactsEditable',
          dataConfig: {
            form: this.getFormsServiceLocal.getContacts(),
            groupConfigs: this.getConfigSiteService.getContactConfigs(),
            content: this.mapDataContactToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
        {
          titleTab: 'Miscellaneous',
          contentTab: 'miscellaneousEditable',
          dataConfig: {
            form: this.getFormsService.getMiscellaneous(),
            groupConfigs: this.getConfigSiteService.getMiscellaneousConfigs(),
            content: this.mapDataMiscellaneousToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
        {
          titleTab: 'Invoices',
          contentTab: 'invoicesList',
          dataConfig: this.getInvoicesListData().dataTabs[0].dataConfig,
          role: 'BO_BILLING_INVOICES_VIEW',

        },
        {
          titleTab: 'Contracts',
          contentTab: 'datatableContracts',
          dataConfig: this.getSiteContractsListData().dataTabs[0].dataConfig,
          role: 'BO_BILLING_INVOICES_VIEW',
        },
      ]
    }
  }
  getSiteDetailsMultiDataNoPlayer(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Subscriptions',
          contentTab: 'subscriptionsList',
          dataConfig: {
            form: this.getFormsService.getFilterSubscriptionSimple(),
            groupConfigs: this.getConfigSiteService.getSubscriptionDetailConfigsSimple(),
            content: [
              {
                name: '',
                prop: 'service.id',
                sortable: true,
                type: 'service'
              },
              {
                name: 'ORDERS_LIST_SUBSCRIPTION_NAME',
                prop: 'displayName',
                sortable: true,
                type: 'detailSubRouterLink',
              },
              {
                name: 'GENERIC_PLAYER_NAME',
                prop: 'players',
                sortable: true,
                type: 'playerName'
              },
              {
                name: 'GENERIC_STATUS',
                prop: 'status',
                sortable: true,
                type: 'iconListSwitch',
                data: [
                  {tooltip: 'SUBSCRIPTIONS_STATUS_EXPLOIT' , icon: 'fa fa-fw fa-flag text-success', value: 3 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_DEMO' , icon: 'fa fa-fw fa-flask text-info', value: 2 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_OFF' , icon: 'fa fa-fw fa-power-off text-danger', value: 1 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_TO_OFF' , icon: 'fa fa-fw fa-flag-checkered text-warning', value: 0 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_STOP' , icon: 'fa fa-fw fa-stop text-danger', value: -1 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_BANKRUPTCY' , icon: 'fas fa-university text-danger', value: -2 }
                ]
              },
              {
                name: 'GENERIC_CLOSE_SUBSCRIPTION',
                prop: 'closed',
                sortable: true,
                type: 'date',
              },
              {
                name: 'GENERIC_PRODUCT_NAME',
                prop: 'product.name',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_CULTURES',
                prop: 'cultures',
                sortable: true,
                type: 'simpleArray',
              },
              {
                name: 'SITE_FILTER_LAST_CONNECTION',
                prop: 'players',
                sortable: true,
                type: 'LastConnectionDate',
              }
            ]
          }
        },
        {
          titleTab: 'Site',
          contentTab: 'siteEditable',
          dataConfig: {
            form: this.getFormsService.getSubscriptionMulti(),
            groupConfigs: this.getConfigSiteService.getSiteConfigs(),
            content: this.mapDataSubscriptionToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          }
        },
        {
          titleTab: 'Addresses',
          contentTab: 'addressesEditable',
          dataConfig: {
            form: this.getFormsService.getAddresses(),
            groupConfigs: this.getConfigSiteService.getAddressesConfigs(),
            content: this.mapDataAddressesToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
        {
          titleTab: 'Contacts',
          contentTab: 'contactsEditable',
          dataConfig: {
            form: this.getFormsServiceLocal.getContacts(),
            groupConfigs: this.getConfigSiteService.getContactConfigs(),
            content: this.mapDataContactToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
        {
          titleTab: 'Miscellaneous',
          contentTab: 'miscellaneousEditable',
          dataConfig: {
            form: this.getFormsService.getMiscellaneous(),
            groupConfigs: this.getConfigSiteService.getMiscellaneousConfigs(),
            content: this.mapDataMiscellaneousToForm(this.storeSites.pipe(select(fromSites.selectors.getSite)))
          },
        },
      ]
    }
  }
  getSiteContractsListData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Contracts',
          contentTab: 'datatableContracts',
          dataConfig: {
            form: this.getFormsService.getFilterContract(),
            groupConfigs: this.getConfigSharedService.getContractSiteFilter(),
            header :  {
              icon: 'fal fa-file-signature',
              text: 'GENERIC_CONTRACTS',
            } ,
            content: [
              {
                name: '',
                prop: 'service',
                sortable: false,
                type: 'activeBillingLink'
              },
              {
                name: '',
                prop: 'service',
                sortable: false,
                type: 'service'
              },
              {
                name: 'GENERIC_NAME',
                prop: 'displayName',
                sortable: true,
                type: 'detailRouterLink',
                path: 'contractDetail',
                //  fragment: contract
              },
              // {
              //   name: 'CONTRACT_PURCHASE_ORDER',
              //   prop: 'po',
              //   sortable: true,
              //   type: 'text',
              // },

              {
                name: 'CONTRACT_START_DATE',
                prop: 'startDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'CONTRACT_END_DATE',
                prop: 'endDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'CONTRACT_TIME_LINE_START_DATE',
                prop: 'startTimeLinks',
                sortable: true,
                type: 'date'
              },
              {
                name: 'CONTRACT_TIME_LINE_END_DATE',
                prop: 'endTimeLinks',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_COMPANY_NAME',
                prop: 'companyName',
                sortable: true,
                type: 'routerLink',
                path: 'companyName',
              },
              {
                name: 'GENERIC_PRICE',
                prop: 'price',
                sortable: true,
                type: 'concatenatePrice',
                concatenate: ['price', 'currencyIsoCode'],
                emptyData: 'CONTRACT_LIST_PRICE_EMPTY_DATA',
              },
              {
                name: 'GENERIC_PRODUCT',
                prop: 'productName',
                sortable: true,
                type: 'text'
              },
              // {
              //   name: 'GENERIC_LAST_INVOICE_CALCULATION',
              //   prop: 'lastInvoiceCalculation',
              //   sortable: true,
              //   type: 'date'
              // },
              // {
              //   name: 'GENERIC_REMOVED',
              //   prop: 'deleted',
              //   sortable: true,
              //   type: 'date'
              // },
            ]
          },
        }
      ]
    }
  }
  getSitesListData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Sites',
          contentTab: 'sitesList',
          dataConfig: {}
        },
        {
          titleTab: 'Subscriptions',
          contentTab: 'subscriptionsListSimple',
          dataConfig: this.getSubListData().dataTabs[0].dataConfig,
        },
        {
          titleTab: 'Contract links',
          contentTab: 'subscriptionsList',
          dataConfig: this.getCompanySubListData().dataTabs[0].dataConfig,
        },
        {
          titleTab: 'Configuration',
          contentTab: 'playerConfigurationEditable',
          dataConfig: {
            form: null,
            groupConfigs: null,
          },
        },
        {
          titleTab: 'Projects',
          contentTab: 'projectsList',
          dataConfig: this.getProjectsListData().dataTabs[0].dataConfig,
        },
      ]
    }
  }

  /**
   * subscriber qui attend les donn�es.
   * Cr�e un formulaire et sa config et inject tous sa dans un subject.
   *
   */

  waitConfDefAndConfForm(): void {
    const dataTab = [];
    this.sub$ = combineLatest(
      this.storeSites.pipe(select(fromShared.selectors.getPlayerConfigurationEdit), filter(data => !_.isEmpty(data))),
      this.storeSites.pipe(select(fromShared.selectors.getPlayerConfigDef), filter(data => !_.isEmpty(data))),
    ).pipe(map(([editData, configData]) => {
      if (editData.length > 0 && configData.length > 0) {
        dataTab['form'] = this.playerConfigurationService.getForm(this.getFormsService.getPlayerConfiguration(), editData, configData);
        dataTab['groupConfigs'] =
          this.playerConfigurationService.getGroupConfigs(this.getConfigSiteService.getPlayerConfigurationsConfigs(), editData, configData);
        return dataTab;
      }
    }));
    this.sub$.pipe(take(1)).subscribe(x => this.subject.next(x));
    this.subscriptions.push(this.sub$);
  }

  getResponse(): Observable<object> {
    return this.subject.asObservable();
  }

  /**
   * cette fonction reinitialise le subject une fois le travailler terminer
   *
   */
  destroy(): void {
    this.subject.next('');
    this.subject.complete();
    this.subject = new BehaviorSubject<Object>('');
    // if (this.subscriptions.length) {
    //   this.subscriptions.forEach(sub => sub.unsubscribe());
    // }
  }

  mapDataSubscriptionToForm(data: Observable<Site>): Observable<SubscriptionSiteForm> {

    return data.pipe(
      skipWhile((s: Site) => !s),
      map(sub => this.siteMapperService.subscriptionDbToForm(sub))
    )
  }

  mapDataNetworkToForm(data: Observable<Site>): Observable<NetworkSettings> {
    return data.pipe(
      skipWhile((s: Site) => !s || (s && !s.subscriptions[0])),
      map(sub => this.orderMapperService.networkDbToForm(sub.subscriptions[0].network))
    )
  }

  mapDataAddressesToForm(data: Observable<Site>): Observable<Address[]> {
    return data.pipe(
      skipWhile((s: Site) => !s),
      map(sub => (sub.addresses))
    )
  }

  mapDataContactToForm(data: Observable<Site>): Observable<Contact[]> {
    return data.pipe(
      skipWhile((s: Site) => !s),
      map(sub => (sub.contacts.map(contact => contact.contact)))
    )
  }

  mapDataMiscellaneousToForm(data: Observable<Site>): Observable<MiscellaneousSiteForm> {
    return data.pipe(
      skipWhile((s: Site) => !s),
      map(site => this.siteMapperService.miscellaneousDbToForm(site))
    )
  }
  mapDataMiscellaneousToFormMulti(data: Observable<Site>): Observable<MiscellaneousSiteForm> {
    return data.pipe(
      skipWhile((s: Site) => !s),
      map(site => this.siteMapperService.miscellaneousDbToFormMulti(site))
    )
  }

  canChangeDefault(data: Observable<Site>): boolean {
    // player already default

    return this.getOrderOpenStatus(data);
  }

  getOrderOpenStatus(data: Observable<Site>): boolean {
    let isorderOpen: boolean;
    data.pipe(
      skipWhile((s: Site) => !s),
      map(site => isorderOpen = site.subscriptions[0].isOrderOpened)
    );
    return isorderOpen;
  }
  // tslint:disable-next-line:no-any
  getOrderOpenStatusWithRom(data: Observable<Site> ): boolean {
    let isorderOpen: boolean;
    data.pipe(
      skipWhile((s: Site) => !s),
      map(site => {
        for (let j = 0; j < site.subscriptions.length; j++) {
          if (this.router.url.split('?')[0].split('/')[5]
            && this.router.url.split('?')[0].split('/')[5]
            === site.subscriptions[j].uuid) {
            isorderOpen = site.subscriptions[j].isOrderOpened ;
          }
        }
      })
    );
    return isorderOpen;
  }

  getInvoicesListData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Invoices',
          contentTab: 'invoicesList',
          dataConfig: {
            form: this.getFormsSharedService.getFilterCompanyInvoices(),
            groupConfigs: this.getConfigSharedService.getInvoicesSiteFilter(),
            header: {
              icon: 'fal fa-wallet',
              text: 'GENERIC_INVOICES'
            },
            content: [
              {
                name: 'GENERIC_CODE',
                prop: 'code',
                sortable: true,
                type: 'text',
              },
              {
                name: 'INVOICES_LOGISTIC_JOURNAL',
                prop: 'logisticJournal',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_COMPANY_NAME',
                prop: 'companyName',
                sortable: true,
                type: 'routerLink',
                path: 'companyName',
              },
              // {
              //   name: 'GENERIC_CONTRACT_NAME',
              //   prop: 'contractName',
              //   sortable: true,
              //   type: 'routerLink',
              //   path: 'contractName',
              // },
              {
                name: 'GENERIC_COVERS_START',
                prop: 'coverStart',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_COVERS_END',
                prop: 'coverEnd',
                sortable: true,
                type: 'date'
              },
              {
                name: 'CONTRACT_PURCHASE_ORDER',
                prop: 'purchaseOrder',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_INVOICE_NUMBER',
                prop: 'number',
                sortable: true,
                type: 'detailRouterLink',
                path: 'invoicesDetail',
              },
              {
                name: 'GENERIC_SPLIT',
                prop: 'split',
                sortable: true,
                type: 'select',
                data: [
                  { id: 1, name: 'PO' },
                  { id: 2, name: 'Site' },
                  { id: 3, name: 'Country' },
                  { id: 4, name: 'Contract' },
                  { id: 5, name: 'Client' },
                  { id: 6, name: 'Company' },
                ]
              },
              {
                name: '',
                prop: 'isAdjustment',
                sortable: false,
                type: 'icon',
                icon: {
                  classFn: (row): string => (row.isAdjustment ? 'far fa-file-invoice-dollar' : ''),
                  tooltip: 'GENERIC_INVOICE_IS_ADJUSTMENT'
                }
              },
              {
                name: 'GENERIC_COUNTRY',
                prop: 'countryCode',
                sortable: true,
                type: 'country',
              },
              {
                name: 'GENERIC_OFFICE',
                prop: 'officeID',
                sortable: true,
                array: [  { id: 1, name: 'OFFICE_BE' },
                          { id: 2, name: 'OFFICE_FR' },
                          { id: 3, name: 'OFFICE_ES' },
                          { id: 4, name: 'OFFICE_DE' },
                          { id: 5, name: 'OFFICE_CN' },
                          { id: 6, name: 'OFFICE_IT' },
                          { id: 7, name: 'OFFICE_NL' },
                          { id: 8, name: 'OFFICE_UK' },
                          { id: 9, name: 'OFFICE_HK' }],
                type: 'array'
              },
              // {
              //   name: 'INVOICES_LINE_CODE',
              //   prop: 'invoiceLineCode',
              //   sortable: true,
              //   type: 'text'
              // },
              // {
              //   name: 'INVOICES_LINE_NAME',
              //   prop: 'invoiceLineName',
              //   sortable: true,
              //   type: 'text'
              // },
              // {
              //   name: '#',
              //   prop: 'count',
              //   sortable: true,
              //   type: 'tooltipText',
              //   tooltip: 'Subscription',
              // },
              // {
              //   name: 'GENERIC_UNIT_PRICE',
              //   prop: 'unitPrice',
              //   sortable: true,
              //   type: 'text'
              // },
              {
                name: 'GENERIC_TOTAL',
                prop: 'total',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_CREATED',
                prop: 'created',
                sortable: true,
                type: 'date'
              },
            ]
          },
        }
      ]
    }
  }
}
